export default {
  nav: {
    dashboard: "Inicio",
    announcements: "Anuncios",
    time: "Reloj",
    pto: "Días Libres",
    tasks: "Tableros",
    goals: "Mis Metas",
    reviews: "Mis Evaluaciones",
    shifts: "Mis Turnos",
    production: "Mi Producción",
    checklists: "Listas",
    training: "Capacitación",
    orders: "Pedidos",
    support: "Soporte",
    oneOnOnes: "Notas 1:1",
    kudos: "Reconocimientos",
    suggestions: "Sugerencias",
    polls: "Encuestas",
    directory: "Directorio",
    sops: "Procedimientos",
    handbook: "Manual",
    resources: "Recursos",
    chat: "Chat",
    profile: "Mi Perfil",
  },
  dashboard: {
    hi: "Hola, {{name}}",
    status: "Estado",
    clockedIn: "Trabajando",
    offTheClock: "Fuera de turno",
    since: "Desde",
    today: "Hoy",
    thisWeek: "Esta semana",
    verification: "Verificación",
    clockIn: "Entrar",
    clockOut: "Salir",
    recentLogs: "Registros recientes",
    viewAll: "Ver todo",
    noLogs: "Sin registros en los últimos 14 días.",
    sickCardTitle: "¿No te sientes bien?",
    sickCardBody: "Un toque envía una solicitud de día libre y avisa al supervisor.",
    sickButton: "🤒 Reportarme enfermo hoy",
    sickConfirm: "¿Reportarte enfermo hoy?",
    sickConfirmBody: "Esto envía una solicitud de día libre marcada como \"enfermedad\" y avisa al supervisor.",
    sickThanks: "Gracias — ya se le avisó al supervisor. Mejórate pronto.",
    mobileBlocker: "Marca entrada desde una computadora",
    mobileBlockerBody: "Para llevar las horas correctamente, marca entrada en una computadora o en el kiosco del almacén.",
  },
  kiosk: {
    pickName: "Toca tu nombre y escribe tu PIN para marcar entrada o salida.",
    enterPin: "Escribe tu PIN",
    cancel: "Cancelar",
    clockAction: "Marcar Entrada / Salida",
    forgotPin: "Olvidé mi PIN",
    forgotPinSent: "Se le avisó al supervisor — ellos pondrán tu PIN nuevo.",
    noPinSet: "Sin PIN",
    cameraDenied: "No hay acceso a la cámara",
    cameraUnavailable: "Cámara no disponible",
    cameraStarting: "Iniciando cámara…",
    retry: "Intentar de nuevo",
  },
  timeoff: {
    title: "Días Libres",
    newRequest: "+ Solicitar Día Libre",
    unpaidNotice: "Aviso — los días libres actualmente son **sin pago**. Envía tus fechas y tu supervisor las aprobará o rechazará.",
    upcomingApproved: "Días libres aprobados próximos",
    startDate: "Fecha de inicio",
    endDate: "Fecha de fin",
    reason: "Razón",
    notes: "Notas",
    notesPlaceholder: "Algún contexto para tu supervisor…",
    submit: "Enviar solicitud",
    cancel: "Cancelar",
    confirmCancel: "¿Cancelar esta solicitud de días libres?",
    myRequests: "Mis solicitudes",
    noRequests: "Aún no has hecho solicitudes.",
    reasons: {
      vacation: "Vacaciones",
      sick: "Enfermedad",
      personal: "Personal",
      bereavement: "Duelo familiar",
      jury_duty: "Jurado",
      other: "Otro",
    },
    status: {
      pending: "pendiente",
      approved: "aprobada",
      denied: "rechazada",
      cancelled: "cancelada",
    },
  },
  common: {
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    close: "Cerrar",
    yes: "Sí",
    no: "No",
    loading: "Cargando…",
    actions: "Acciones",
  },
  profile: {
    title: "Mi Perfil",
    saved: "Guardado",
    sections: {
      personal: "Personal",
      contact: "Contacto",
      emergency: "Emergencia",
      banking: "Banco e Impuestos",
      documents: "Documentos",
      security: "Seguridad",
    },
    firstName: "Nombre",
    lastName: "Apellido",
    middleName: "Segundo nombre",
    preferredName: "Nombre preferido",
    preferredPronouns: "Pronombres (él, ella, elle)",
    dateOfBirth: "Fecha de nacimiento",
    maritalStatus: "Estado civil",
    gender: "Género",
    bio: "Biografía",
    linkedinUrl: "Enlace de LinkedIn",
    shirtSize: "Talla de camisa (para la playera de la empresa)",
    languages: "Idiomas",
    phone: "Celular",
    homePhone: "Teléfono de casa",
    personalEmail: "Correo personal",
    address: "Dirección",
    city: "Ciudad",
    state: "Estado",
    zipCode: "Código postal",
    changePassword: "Cambiar contraseña",
    newPassword: "Contraseña nueva",
    update: "Actualizar",
    account: "Cuenta",
    username: "Usuario (para @menciones)",
    employeeNumber: "Número de empleado",
    email: "Correo",
    role: "Puesto",
    memberSince: "Miembro desde",
    appearance: "Apariencia",
    matchSystem: "Sistema",
    light: "Claro",
    dark: "Oscuro",
    language: "Idioma",
    twoFactor: "Verificación de dos pasos",
    enable2fa: "Activar 2FA",
    scanQr: "Escanea este código QR con tu app de autenticación y escribe el código de 6 dígitos que te muestre.",
    enterCode: "Escribe el código de 6 dígitos",
    verify: "Verificar",
    removeFactor: "Quitar",
    upload: "Subir",
    uploadFile: "Elegir archivo",
    myDocuments: "Mis documentos",
    nothingUploaded: "Aún no has subido nada.",
  },
  polls: {
    title: "Encuestas",
    subtitle: "Vota de forma anónima — no se guarda tu nombre.",
    newPoll: "Nueva encuesta",
    noPolls: "No hay encuestas por ahora.",
    question: "Pregunta",
    description: "Descripción",
    optional: "opcional",
    options: "Opciones",
    addOption: "+ Agregar opción",
    multiSelect: "Selección múltiple",
    closesAt: "Cierra el",
    open: "abierta",
    closed: "cerrada",
    multiSelectShort: "selección múltiple",
    vote: "Votar",
    alreadyVoted: "Ya votaste en esta encuesta.",
    votes: "votos",
    closes: "cierra",
    close: "Cerrar",
    reopen: "Reabrir",
    delete: "Eliminar",
    errorNeedTwoOptions: "Necesitas una pregunta y al menos 2 opciones.",
    create: "Crear encuesta",
    creating: "Creando…",
  },
  chat: {
    channels: "Canales",
    directMessages: "Mensajes directos",
    noOthers: "Aún no hay otros empleados.",
    selectConversation: "Elige una conversación",
    noMessages: "Aún no hay mensajes. Saluda.",
    messagePlaceholder: "Mensaje para {{name}} — usa @ para mencionar",
    startHuddle: "Iniciar llamada",
    huddleRunning: "Llamada en",
    copy: "copiar",
    delete: "eliminar",
    send: "Enviar",
    noConversation: "Elige una conversación",
  },
};
